// 时间同步工具类（time-sync.ts）
export class TimeSync {
  // 客户端与服务端的时间偏差（毫秒）：服务端时间 - 客户端时间
  private static timeOffset: number = 0;
  // 是否已初始化
  private static isInitialized: boolean = false;

  /**
   * 初始化：首次从服务端获取时间，计算偏差
   * @param fetchServerTime 调用服务端接口的函数（返回服务端当前UTC时间戳）
   */
  public static async init(fetchServerTime: () => Promise<number>) {
    if (this.isInitialized) return;

    try {
      // 1. 获取客户端当前UTC时间（毫秒）
      const clientNow = Date.now();
      // 2. 调用服务端接口获取服务端当前UTC时间（毫秒）
      const serverNow = await fetchServerTime();
      // 3. 计算偏差：服务端时间 - 客户端时间（后续用客户端时间 + 偏差 = 服务端时间）
      this.timeOffset = serverNow - clientNow;
      this.isInitialized = true;
      console.log("时间校准完成，偏差：", this.timeOffset, "ms");
    } catch (error) {
      console.error("时间校准失败，将使用本地时间", error);
      this.timeOffset = 0; // 失败时默认无偏差（依赖本地时间）
      this.isInitialized = true;
    }
  }

  /**
   * 获取校准后的当前时间（等效于服务端当前UTC时间）
   */
  public static getServerTime(): number {
    if (!this.isInitialized) {
      console.warn("时间未初始化，暂时使用本地时间");
      return Date.now();
    }
    // 客户端当前时间 + 偏差 = 服务端时间
    return Date.now() + this.timeOffset;
  }

  /**
   * 定时重新校准（可选，适用于长时间运行的页面）
   * @param fetchServerTime 同init的接口函数
   * @param interval 校准间隔（毫秒，默认10分钟）
   */
  public static startPeriodicSync(fetchServerTime: () => Promise<number>, interval: number = 10 * 60 * 1000) {
    setInterval(() => {
      this.init(fetchServerTime); // 复用init方法重新校准
    }, interval);
  }
}